import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import 'antd/dist/antd.css';

const StyledButton = styled(Button)`
  height: 50px !important;
  color: ${ props => !props.disabled && props.textcolor} !important;
  background-color: ${ props => !props.disabled && props.backgroundcolor} !important;
  border-color: ${ props => !props.disabled && props.bordercolor} !important;
  width: ${ props => !props.disabled && props.width} !important;
  border-radius: 25px !important;

  span {
    font-size: 20px !important;
    font-family: Thonburi Bold;
  }
`;

const StyledMain = styled.div`
  text-align: center;
  width: 100%;
`;

const ButtonComponent = (props) => {
  return (
    <StyledMain>
      <StyledButton
        onClick={props.onClick}
        textcolor={props.textcolor}
        bordercolor={props.bordercolor}
        backgroundcolor={props.backgroundcolor}
        width={props.width}
        disabled={props.disabled}>
        {props.text}
      </StyledButton>
    </StyledMain>
  )
}

ButtonComponent.propTypes = {
  textcolor: PropTypes.string.isRequired,
  bordercolor: PropTypes.string.isRequired,
  backgroundcolor: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  width: PropTypes.string,
  onClick: PropTypes.func
};

ButtonComponent.defaultProps = {
  width: '90%'
};

export default ButtonComponent;
